import { render, staticRenderFns } from "./evaluations.vue?vue&type=template&id=2bcc04e4&"
import script from "./evaluations.vue?vue&type=script&lang=js&"
export * from "./evaluations.vue?vue&type=script&lang=js&"
import style0 from "./evaluations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports